import { transpose, convertRowsToData } from '../utils/dataUtils'
export default function LineAndBarDataController(rows) {
  let headers = rows[0]
  let propperHeaders
  propperHeaders = ['id', ...headers.slice(1)]
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], headers.length - 1)

  let barIds = [propperHeaders[1]]
  let lineIds = propperHeaders.splice(2)
  let lines = data.map(d => {
    return {
      id: d.id,
      value: lineIds.map(lineId => {
        return {
          id: lineId,
          parentId: d.id,
          value: +d.value.find(dd => dd.id === lineId).value,
        }
      }),
    }
  })

  lines = transpose(lines)
  lines.forEach(line => {
    line.value.forEach(point => {
      point.id = point.parentId
      point.parentId = line.id
    })
  })

  let bars = data.map(d => {
    return {
      id: d.id,
      value: +d.value.find(dd => dd.id === barIds[0]).value,
    }
  })
  bars.id = barIds[0]
  return { lines, bars }
}
